/**
 * LEGACY - Gallery Dialog Modal for image galleries
 */

/**
 * LEGACY - Gallery Dialog Modal for image galleries
 */
window.addEventListener('DOMContentLoaded', function () {
	const galleryDialogs = document.querySelectorAll(
		'.is-style-modal-gallery-dialog, .is-style-modal-a11y-dialog'
	);
	if (!galleryDialogs.length) return;

	galleryDialogs.forEach((modalDialogSource) => {
		const galleryDialogFigures = modalDialogSource.querySelectorAll('figure.wp-block-image');
		if (!galleryDialogFigures.length) return;

		function buildSwiperMarkup(figures) {
			const swiperDiv = document.createElement('div');
			swiperDiv.classList.add('swiper', 'modalSwiperWrapper');
			const swiperWrapper = document.createElement('div');
			swiperWrapper.classList.add('swiper-wrapper');
			swiperDiv.appendChild(swiperWrapper);

			figures.forEach((figure) => {
				const link = figure.querySelector('a');
				const image = figure.querySelector('img');
				if (!link || !image) return;

				link.setAttribute('aria-label', 'Show image in lightbox');

				const slide = document.createElement('figure');
				slide.classList.add('swiper-slide');

				const img = image.cloneNode(true);
				img.removeAttribute('fetchpriority');
				img.removeAttribute('decoding');
				const fullHref = link.href;
				img.src = fullHref;
				img.srcset = fullHref;
				img.loading = 'lazy';
				slide.appendChild(img);

				const figcaption = figure.querySelector('figcaption');
				if (figcaption) {
					const caption = document.createElement('figcaption');
					caption.textContent = figcaption.textContent;
					slide.appendChild(caption);
				}
				swiperWrapper.appendChild(slide);
			});
			return swiperDiv;
		}

		const swiperDiv = buildSwiperMarkup(galleryDialogFigures);
		const paginationEl = document.createElement('div');
		paginationEl.classList.add('swiper-pagination');
		const nextEl = document.createElement('div');
		nextEl.classList.add('swiper-next', 'swiper-nav');
		const prevEl = document.createElement('div');
		prevEl.classList.add('swiper-prev', 'swiper-nav');
		swiperDiv.appendChild(paginationEl);
		swiperDiv.appendChild(nextEl);
		swiperDiv.appendChild(prevEl);

		const dialog = document.createElement('dialog');
		dialog.classList.add('dialog-modal-gallery', 'vueDialog', 'imageGalleryVue');

		const closeButton = document.createElement('button');
		closeButton.className = 'close';
		closeButton.type = 'button';
		closeButton.innerHTML = '&#215;';
		closeButton.addEventListener('click', () => dialog.close());
		dialog.appendChild(closeButton);

		modalDialogSource.parentNode.appendChild(dialog);
		dialog.appendChild(swiperDiv);

		let swiper;
		try {
			swiper = new Swiper(swiperDiv, {
				slidesPerView: 'auto',
				direction: 'horizontal',
				grabCursor: true,
				preloadImages: false,
				lazy: { enabled: true, loadOnTransitionStart: true },
				keyboard: { enabled: true, onlyInViewport: true },
				pagination: { el: paginationEl, clickable: true, type: 'fraction' },
				navigation: { nextEl: '.swiper-next', prevEl: '.swiper-prev' },
			});
		} catch (err) {
			console.error('Swiper init failed', err);
			return;
		}

		galleryDialogFigures.forEach((figure, index) => {
			figure.addEventListener('click', (e) => {
				e.preventDefault();
				dialog.showModal();
				swiper.slideTo(index, 250);
				swiper.lazy.load();
			});
		});
	});
});
